export enum FilterTypes {
	BOOLEAN,
	DATE,
	DATE_EXPIRED,
	HTML,
	LICENCES,
	USER,
	NUMBER,
	ENUM,
}
